export const platformAccess = {
  junior: {
    required: [
      { platform: 'JIRA', access: 'Product Owner', purpose: 'Product backlog and sprint management', setup: 'Request product owner role in relevant projects' },
      { platform: 'Confluence', access: 'Editor', purpose: 'Product documentation and requirements', setup: 'Request editor access to product spaces' },
      { platform: 'Slack', access: 'Member', purpose: 'Cross-team communication', setup: 'Join #product-team, #engineering, #design channels' },
      { platform: 'Google Analytics', access: 'Analyst', purpose: 'Product usage analytics', setup: 'Request analyst access to product properties' }
    ],
    optional: [
      { platform: 'Figma', access: 'Viewer', purpose: 'Design review and collaboration', setup: 'Request viewer access to design files' },
      { platform: 'Amplitude', access: 'Viewer', purpose: 'Product analytics', setup: 'Request basic analytics access' }
    ]
  },
  mid: {
    required: [
      { platform: 'ProductBoard', access: 'Admin', purpose: 'Product roadmap and feature prioritization', setup: 'Request admin access to product workspace' },
      { platform: 'Amplitude', access: 'Editor', purpose: 'Advanced product analytics', setup: 'Request editor permissions for analytics' },
      { platform: 'Tableau', access: 'Creator', purpose: 'Data visualization and reporting', setup: 'Request creator license for dashboards' },
      { platform: 'Miro', access: 'Editor', purpose: 'Collaborative planning and ideation', setup: 'Request editor access to product boards' }
    ],
    optional: [
      { platform: 'Hotjar', access: 'Admin', purpose: 'User behavior analytics', setup: 'Request admin access for heatmaps and recordings' },
      { platform: 'Intercom', access: 'Admin', purpose: 'Customer communication', setup: 'Request admin access for customer insights' }
    ]
  },
  senior: {
    required: [
      { platform: 'Strategic Planning Platform', access: 'Admin', purpose: 'Long-term strategic planning', setup: 'Request admin access to strategic planning tools' },
      { platform: 'Executive Dashboard', access: 'Admin', purpose: 'Executive reporting and KPIs', setup: 'Request dashboard creation and management permissions' },
      { platform: 'Market Intelligence Tools', access: 'Admin', purpose: 'Competitive analysis and market research', setup: 'Request admin access to market research platforms' },
      { platform: 'Customer Research Platform', access: 'Admin', purpose: 'User research and insights', setup: 'Request admin access to research tools' }
    ],
    optional: [
      { platform: 'Business Intelligence Suite', access: 'Admin', purpose: 'Advanced analytics and reporting', setup: 'Request admin access to BI platforms' },
      { platform: 'CRM Integration', access: 'Admin', purpose: 'Customer data and insights', setup: 'Request integration access to CRM systems' }
    ]
  }
};
